import { render, staticRenderFns } from "./Bussiness.vue?vue&type=template&id=72411668&"
import script from "./Bussiness.vue?vue&type=script&lang=js&"
export * from "./Bussiness.vue?vue&type=script&lang=js&"
import style0 from "./Bussiness.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports